'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useEffect } from 'react';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { usePartnersDialog } from '../_hooks/usePartnersDialog';
import { PARTNERS_LINK_FORM_ID } from '../_utils/labels';
import { PartnersLoginPanel } from './PartnersLoginPanel';

//* DS Modal이 lg(1024)부터 버튼을 가로로 놓는다 — 닫기 버튼 모양도 같은 경계로 바꾼다
const MODAL_ROW_FOOTER_QUERY = '(min-width: 1024px)';
interface PartnersDialogsProps {
  isGuest: boolean;
  hasLinks: boolean;
  isSuspended: boolean;
  onExitDemo?: () => void;
}
export const PartnersDialogs = t0 => {
  const $ = _c(43);
  const {
    isGuest,
    hasLinks,
    isSuspended,
    onExitDemo
  } = t0;
  const {
    dialog,
    openLoginDialog,
    closeDialog
  } = usePartnersDialog();
  const router = useCustomRouter();
  const isRowFooter = useMediaQuery(MODAL_ROW_FOOTER_QUERY);
  let t1;
  let t2;
  if ($[0] !== closeDialog) {
    t1 = () => closeDialog;
    t2 = [closeDialog];
    $[0] = closeDialog;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== closeDialog || $[4] !== hasLinks || $[5] !== isGuest || $[6] !== onExitDemo || $[7] !== openLoginDialog || $[8] !== router) {
    t3 = () => {
      if (isGuest) {
        openLoginDialog();
        return;
      }
      closeDialog();
      onExitDemo?.();
      if (hasLinks) {
        return;
      }
      const linkForm = document.getElementById(PARTNERS_LINK_FORM_ID);
      if (linkForm) {
        linkForm.scrollIntoView({
          block: "start"
        });
        return;
      }
      router.push(`${DONATION_ROUTES.PARTNERS.pathname}#${PARTNERS_LINK_FORM_ID}`);
    };
    $[3] = closeDialog;
    $[4] = hasLinks;
    $[5] = isGuest;
    $[6] = onExitDemo;
    $[7] = openLoginDialog;
    $[8] = router;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleGoToLinkForm = t3;
  let t4;
  if ($[10] !== router) {
    t4 = () => {
      router.back(DONATION_ROUTES.HOME.pathname);
    };
    $[10] = router;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleSuspendedConfirm = t4;
  const t5 = dialog === "demo";
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="break-keep font-700 typo-body2">지금은 예시 화면이에요</span>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <>실제 파트너스 링크를 만들고<br />내 실적을 확인해 보세요</>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = isRowFooter ? "sub-fill" : "sub-text";
  let t9;
  if ($[14] !== closeDialog || $[15] !== t8) {
    t9 = <Button dimensions="H48" theme={t8} onClick={closeDialog}>닫기</Button>;
    $[14] = closeDialog;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== handleGoToLinkForm) {
    t10 = <Button dimensions="H48" onClick={handleGoToLinkForm}>링크 만들러 가기</Button>;
    $[17] = handleGoToLinkForm;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="flex flex-1 flex-col-reverse gap-2 lg:flex-row lg:gap-8 [&>*]:flex-1">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== closeDialog || $[23] !== t11 || $[24] !== t5) {
    t12 = <Modal closeButton={true} opened={t5} header={t6} description={t7} onClose={closeDialog} buttonFooter={t11} />;
    $[22] = closeDialog;
    $[23] = t11;
    $[24] = t5;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== closeDialog || $[27] !== dialog) {
    t13 = dialog === "login" ? <PartnersLoginPanel redirectPath={`${DONATION_ROUTES.PARTNERS.pathname}#${PARTNERS_LINK_FORM_ID}`} onClose={closeDialog} /> : null;
    $[26] = closeDialog;
    $[27] = dialog;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="break-keep font-700 typo-body2">파트너스 이용이 정지됐어요.</span>;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <br />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <br />;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="block break-keep text-center">새 링크를 만들 수 없으며, 기존 링크를 통한 기부도 보상 대상에서 제외돼요.{t15}지급 예정인 보상은 보류되며,{t16}자세한 내용은 고객센터로<br />문의해 주세요.</span>;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== handleSuspendedConfirm) {
    t18 = <Button dimensions="H48" onClick={handleSuspendedConfirm}>확인</Button>;
    $[33] = handleSuspendedConfirm;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== handleSuspendedConfirm || $[36] !== isSuspended || $[37] !== t18) {
    t19 = <Modal headerClassName="lg:justify-center" opened={isSuspended} header={t14} description={t17} onClose={handleSuspendedConfirm} buttonFooter={t18} />;
    $[35] = handleSuspendedConfirm;
    $[36] = isSuspended;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t12 || $[40] !== t13 || $[41] !== t19) {
    t20 = <>{t12}{t13}{t19}</>;
    $[39] = t12;
    $[40] = t13;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
};